(function () {
  function waitForSlick(callback) {
    var attempts = 0;
    var timer = setInterval(function () {
      if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.slick === 'function') {
        clearInterval(timer);
        callback(window.jQuery);
        return;
      }
      attempts += 1;
      if (attempts > 250) {
        clearInterval(timer);
      }
    }, 20);
  }

  function readBool(value) {
    return value === 'true' || value === true;
  }

  function readSpeed(root, fallback) {
    var speed = parseInt(root.getAttribute('data-slider-autoplay-speed'), 10);
    return Number.isFinite(speed) ? speed : fallback;
  }

  function initFeaturedFav($) {
    document.querySelectorAll('[data-featured-fav-slider]').forEach(function (root) {
      if (root.classList.contains('mila-index-slider-ready')) return;

      var detail = root.closest('.featured_fav_detail');
      if (!detail) return;

      var prevArrow = detail.querySelector('.feature-slider-previous');
      var nextArrow = detail.querySelector('.feature-slider-next');
      var $slider = $(root);

      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        autoplay: readBool(root.getAttribute('data-slider-autoplay')),
        autoplaySpeed: readSpeed(root, 5000),
        speed: 800,
        infinite: true,
        dots: false,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: $(prevArrow),
        nextArrow: $(nextArrow),
      });

      root.classList.add('mila-index-slider-ready');
    });
  }

  function initImgWithText($) {
    document.querySelectorAll('[data-section] .img-with-text-slider').forEach(function (root) {
      if (root.classList.contains('mila-index-slider-ready')) return;

      var section = root.closest('[data-section]');
      if (!section) return;

      var $slider = $(root);
      if ($slider.hasClass('slick-initialized')) return;

      $slider.slick({
        autoplay: readBool(root.getAttribute('data-slider-autoplay')),
        autoplaySpeed: readSpeed(root, 5000),
        speed: 800,
        infinite: true,
        dots: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: false,
        centerPadding: '0',
        adaptiveHeight: true,
        appendDots: $(section.querySelector('.slick-slider-dots')),
        prevArrow: $(section.querySelector('.slider-dots-arrow-prev')),
        nextArrow: $(section.querySelector('.slider-dots-arrow-next')),
        responsive: [
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '250px',
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              centerMode: true,
              centerPadding: '20px',
              speed: 500,
            },
          },
        ],
      });

      root.classList.add('mila-index-slider-ready');
    });
  }

  function initCustomReview($) {
    if (window.MilaCustomReviewSlider && typeof window.MilaCustomReviewSlider.init === 'function') {
      window.MilaCustomReviewSlider.init($);
    }
  }

  function initAll($) {
    initFeaturedFav($);
    initImgWithText($);
    initCustomReview($);
  }

  function boot() {
    waitForSlick(initAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
